(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('agent-supplier-contract', {
                parent: 'entity',
                url: '/agent-supplier-contract?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.agentSupplierContract.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/agent-supplier-contract/agent-supplier-contracts.html',
                        controller: 'AgentSupplierContractController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('agentSupplierContract');
                        $translatePartialLoader.addPart('agentSupplierContractStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('agent-supplier-contract-detail', {
                parent: 'entity',
                url: '/agent-supplier-contract/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.agentSupplierContract.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/agent-supplier-contract/agent-supplier-contract-detail.html',
                        controller: 'AgentSupplierContractDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('agentSupplierContract');
                        $translatePartialLoader.addPart('agentSupplierContractStatus');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'AgentSupplierContract', function ($stateParams, AgentSupplierContract) {
                        return AgentSupplierContract.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('agent-supplier-contract.new', {
                parent: 'agent-supplier-contract',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/agent-supplier-contract/agent-supplier-contract-dialog.html',
                        controller: 'AgentSupplierContractDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    createDate: null,
                                    commision: null,
                                    startDate: null,
                                    endDate: null,
                                    status: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('agent-supplier-contract', null, {reload: true});
                    }, function () {
                        $state.go('agent-supplier-contract');
                    });
                }]
            })
            .state('agent-supplier-contract.edit', {
                parent: 'agent-supplier-contract',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/agent-supplier-contract/agent-supplier-contract-dialog.html',
                        controller: 'AgentSupplierContractDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['AgentSupplierContract', function (AgentSupplierContract) {
                                return AgentSupplierContract.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('agent-supplier-contract', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('agent-supplier-contract.delete', {
                parent: 'agent-supplier-contract',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/agent-supplier-contract/agent-supplier-contract-delete-dialog.html',
                        controller: 'AgentSupplierContractDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['AgentSupplierContract', function (AgentSupplierContract) {
                                return AgentSupplierContract.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('agent-supplier-contract', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
